import { BackNavProps, NavigationBarBreadCrumbs } from "@/components/molecules/BackNav"
import { useMemo } from "react"
import { ManageOrganizationTabs, useManageOrganizationContext } from "../ManageOrganizationContext";
import { useOrganizationStore } from "@/lib/zustand/useStore";

export function ManageOrganizationBreadCrumbs() {
    const { currentTab, setCurrentTab, crm, crmProject, crmConfig, setCrm, setCrmProject, setCrmConfig } = useManageOrganizationContext()
    const { organization } = useOrganizationStore()
    const backNavProps: BackNavProps = useMemo(() => {
        type Page = Exclude<BackNavProps['pages'], undefined>[number]

        const baseBreadcrumbs: Page[] = [
            {
                title: "Home",
                goTo: `/welcome`
            },
            {
                title: organization?.name || "-",
                goTo: `/organization/${organization?.id}`
            },
        ];

        const manageOrganizationBreadcrumb: Page = {
            title: "Manage Organization",
            onClick: () => {
                setCrm(null)
                setCrmProject(null)
                setCrmConfig(null)
                setCurrentTab(ManageOrganizationTabs.crm)
            }
        }
        const crmBreadcrumb: Page = {
            title: `CRM: ${crm?.name}`,
            onClick: () => {
                setCrmProject(null)
                setCrmConfig(null)
                setCurrentTab(ManageOrganizationTabs.crm)
            }
        }
        const crmProjectBreadcrumb: Page = {
            title: `CRM Project: ${crmProject?.name}`,
            onClick: () => {
                setCrmConfig(null)
                setCurrentTab(ManageOrganizationTabs.crm_project)
            }
        }
        switch (currentTab) {
            case ManageOrganizationTabs.crm: {
                if (crm) {
                    return {
                        currentPageName: crmBreadcrumb.title,
                        pages: [
                            ...baseBreadcrumbs,
                            manageOrganizationBreadcrumb
                        ]
                    }
                }
                return {
                    currentPageName: manageOrganizationBreadcrumb.title,
                    pages: [
                            ...baseBreadcrumbs,
                        ]
                }
            }
            case ManageOrganizationTabs.crm_project: {
                if (crmProject) {
                    return {
                        currentPageName: crmProjectBreadcrumb.title,
                        pages: [
                            ...baseBreadcrumbs,
                            manageOrganizationBreadcrumb,
                            crmBreadcrumb
                        ]
                    }
                }
                return {
                    currentPageName: `Pick CRM Project`,
                    pages: [
                        ...baseBreadcrumbs,
                        manageOrganizationBreadcrumb,
                        crmBreadcrumb
                    ]
                }
            }
            case ManageOrganizationTabs.crm_config: {
                if (crmConfig) {
                    return {
                        currentPageName: `CRM Config: ${crmConfig.name}`,
                        pages: [
                            ...baseBreadcrumbs,
                            manageOrganizationBreadcrumb,
                            crmBreadcrumb,
                            crmProjectBreadcrumb
                        ]
                    }
                }
                return {
                    currentPageName: `Pick CRM Config`,
                    pages: [
                        ...baseBreadcrumbs,
                        manageOrganizationBreadcrumb,
                        crmBreadcrumb,
                        crmProjectBreadcrumb
                    ]
                }
            }
            default: {
                return {
                    currentPageName: manageOrganizationBreadcrumb.title,
                    pages: [
                        ...baseBreadcrumbs,
                        manageOrganizationBreadcrumb
                    ]
                }
            }
        }
    }, [currentTab, crm, crmProject, crmConfig, setCrmConfig, setCrmProject, setCrm, setCurrentTab])
    return (
        // <BackNav
        //     {...backNavProps}
        // />
        <NavigationBarBreadCrumbs.Set
            {...backNavProps}
        />
    )
}